import React, { useState, useEffect } from 'react';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import { Route, useLocation, useNavigate, Routes } from "react-router-dom";
import { Image, Badge, Col } from 'react-bootstrap';
import HiringPipelines from './hiringPipelines';
import ManageUsers from './manageUsers';
import CVReview from './cvReviews';
import Interviews from './interviews';
import styles from './adminPanel.module.scss';
import PendingInterviews from './interviewSheduling/pendingInterviews';
import SheduledInterviews from './interviewSheduling/sheduledInterviews';
import TableViewInterviews from './interviewSheduling/sheduledInterviews/tableViewInterviews';
import CalendarViewInterviews from './interviewSheduling/sheduledInterviews/calendarViewInterviews';
import EditPipeline from './hiringPipelines/editPipeline';
import ViewPipeline from './hiringPipelines/viewPipeline';
import CandidateSearch from './candidateSearch';
import ViewCV from './cvReviews/viewCV';
import ViewSingleCandidate from './hiringPipelines/viewPipeline/viewCandidates/viewSingleCandidate';
import SingleInterview from './interviews/singleInterview';
import NotFound from './404NotFound';
import Billing from './billing';
import Analytics from './analytics';
import OfferApprovals from './approvals/offer-approvals';
import OfferHandling from './offerHandling';
import FilteredCandidates from './offerHandling/FilteredOffers';
import PendingOnboarding from './pendingOnboarding';
import CompanySettings from './companySettings';
import General from './companySettings/general'
import Integrations from './companySettings/integrations'
import HRISIntegration from './companySettings/hrisIntegration'
import OtherReviews from './otherReviews';
import ViewOtherReviews from './otherReviews/viewOtherReviews';
import ViewCVGroup from './cvReviews/viewCVGroup';
import { getAssignedTasks } from '../../services/util/companyUser';
import ReferenceCheck from './referenceCheck';
import ViewReferenceChecks from './referenceCheck/viewReferenceCheck';
import ViewReferenceCheckGroup from './referenceCheck/viewReferenceCheckGroup';
import CustomEvaluation from './customEvaluation';
import ViewCustomEvaluationGroup from './customEvaluation/viewCustomEvaluationGroup';
import ViewCustomEvaluations from './customEvaluation/viewCustomEvaluation';
import OneWayInterview from './oneWayInterview';
import ViewOneWayInterviewGroup from './oneWayInterview/viewOneWayInterviewGroup';
import EvaluationTemplates from './evaluationTemplates';
import QuizTemplates from './evaluationTemplates/quizTemplates';
import OneWayInterviewTemplates from './evaluationTemplates/oneWayInterviewTemplates';
import ViewQuizTemplates from './evaluationTemplates/quizTemplates/viewQuizTemplate';
import ViewOneWayInterviewTemplate from './evaluationTemplates/oneWayInterviewTemplates/viewOneWayInterviewTemplate';
import EditOneWayInterviewTemplate from './evaluationTemplates/oneWayInterviewTemplates/editOneWayInterviewTemplate';
import ViewOneWayInterview from './oneWayInterview/viewOneWayInterview';
import { checkVacancyPageURLPrefix } from '../../services/util/company'
import CompanySettingModal from './companySettingModal'

const AdminPanel = (props) => {
    let [interviewExpand, setInterviewExpand] = useState(false);
    let [offerExpand, setOfferExpand] = useState(false);
    let [expand, setState] = useState(true);
    let [isLockedState, setIsLockedState] = useState(false);
    let [activeUrl, setActiveUrl] = useState();
    let [isRoutingLoading, setIsRoutingLoading] = useState(false);
    let [assignedTasks, setAssignedTasks] = useState({
        cv_reviews: null,
        interviews: null,
        interviews_to_schedule: null,
    });
    const [completeStatus, setCompleteStatus] = useState(null);
    let [permissions, setPermissions] = useState({
        user_role: '',
        access_levels: {
            hiring_pipeline: {
                is_enabled: false,
                actions: {
                    edit_pipeline: false,
                    delete_pipeline: false,
                    view_pipeline: false
                }
            },
            schedule_interviews: {
                is_enabled: false,
                actions: {
                    view_pending_interviews: false,
                    schedule_interviews: false
                }
            },
            cv_review: {
                is_enabled: false,
                actions: {}
            },
            interviews: {
                is_enabled: false,
                actions: {}
            },
            external_assessment_review: {
                is_enabled: false,
                actions: {}
            },
            manage_users: {
                is_enabled: false,
                actions: {
                    remove_users: false,
                    edit_users: false,
                    view_users: false
                }
            },
            company_settings: {
                is_enabled: false,
                actions: {
                    edit_settings: false,
                    view_settings: false
                }
            },
            billing: {
                is_enabled: false,
                actions: {
                    billing_actions: false,
                    view_billing_details: false
                }
            },
            analytics: {
                is_enabled: false,
                actions: {
                    view_analytics_details: false
                }
            },
            offer_handling: {
                is_enabled: false,
                actions: {
                    view_offers: false,
                    edit_offers: false
                }
            },
            onboarding: {
                is_enabled: false,
                actions: {
                    view_onboards: false,
                    edit_onboards: false,
                    view_offers: false
                }
            },
            approvals: {
                is_enabled: false,
                actions: {}
            },
            quiz_templates: {
                is_enabled: false,
                actions: {
                    edit_quiz_templates: false,
                    delete_quiz_templates: false,
                    view_quiz_templates: false
                }
            },
            reference_check_review: {
                is_enabled: false,
                actions: {}
            },
            custom_evaluation_review: {
                is_enabled: false,
                actions: {}
            },
            one_way_interview_review: {
                is_enabled: false,
                actions: {}
            },
            evaluation_templates: {
                is_enabled: false,
                actions: {
                    edit_evaluation_templates: false,
                    view_evaluation_templates: false,
                    delete_evaluation_templates: false
                }
            },
        },

    })
    let mainHistory = useNavigate();

    const onToggle = (expand) => {
        setState(expand);
    };

    const toggleInterviewView = (isLockedSlide) => {
        setIsLockedState(isLockedSlide);
    }

    const location = useLocation();
    let pathname = location.pathname;

    function setPermissionValues(values) {
        setPermissions((prevState) => ({
            ...prevState,
            user_role: values.user_role,
            access_levels: {
                hiring_pipeline: {
                    is_enabled: values.access_levels.hiring_pipeline.is_enabled,
                    actions: {
                        edit_pipeline: values.access_levels.hiring_pipeline.actions.edit_pipeline,
                        delete_pipeline: values.access_levels.hiring_pipeline.actions.delete_pipeline,
                        view_pipeline: values.access_levels.hiring_pipeline.actions.view_pipeline
                    }
                },
                schedule_interviews: {
                    is_enabled: values.access_levels.schedule_interviews.is_enabled,
                    actions: {
                        view_pending_interviews: values.access_levels.schedule_interviews.actions.view_pending_interviews,
                        schedule_interviews: values.access_levels.schedule_interviews.actions.schedule_interviews
                    }
                },
                cv_review: {
                    is_enabled: values.access_levels.cv_review.is_enabled,
                    actions: {}
                },
                interviews: {
                    is_enabled: values.access_levels.interviews.is_enabled,
                    actions: {}
                },
                external_assessment_review: {
                    is_enabled: values.access_levels.external_assessment_review.is_enabled,
                    actions: {}
                },
                offer_handling: {
                    is_enabled: values.access_levels.offer_handling.is_enabled,
                    actions: {
                        view_offers: values.access_levels.offer_handling.actions.view_offers,
                        edit_offers: values.access_levels.offer_handling.actions.edit_offers,
                    }
                },
                onboarding: {
                    is_enabled: values.access_levels.onboarding.is_enabled,
                    actions: {
                        view_onboards: values.access_levels.onboarding.actions.view_onboards,
                        edit_onboards: values.access_levels.onboarding.actions.edit_onboards,
                        view_offers: values.access_levels.offer_handling.actions.view_offers,
                    }
                },
                approvals: {
                    is_enabled: values.access_levels.approvals.is_enabled,
                    actions: {}
                },
                manage_users: {
                    is_enabled: values.access_levels.manage_users.is_enabled,
                    actions: {
                        remove_users: values.access_levels.manage_users.actions.remove_users,
                        edit_users: values.access_levels.manage_users.actions.edit_users,
                        view_users: values.access_levels.manage_users.actions.view_users
                    }
                },
                company_settings: {
                    is_enabled: values.access_levels.company_settings.is_enabled,
                    actions: {
                        edit_settings: values.access_levels.company_settings.actions.edit_settings,
                        view_settings: values.access_levels.company_settings.actions.view_settings
                    }
                },
                billing: {
                    is_enabled: values.access_levels.billing.is_enabled,
                    actions: {
                        billing_actions: values.access_levels.billing.actions.billing_actions,
                        view_billing_details: values.access_levels.billing.actions.view_billing_details
                    }
                },
                analytics: {
                    is_enabled: values.access_levels.analytics.is_enabled,
                    actions: {
                        view_analytics_details: values.access_levels.analytics.actions.view_analytics_details
                    }
                },
                quiz_templates: {
                    is_enabled: values.access_levels.quiz_templates.is_enabled,
                    actions: {
                        edit_quiz_templates: values.access_levels.quiz_templates.actions.edit_quiz_templates,
                        delete_quiz_templates: values.access_levels.quiz_templates.actions.delete_quiz_templates,
                        view_quiz_templates: values.access_levels.quiz_templates.actions.view_quiz_templates,
                    }
                },
                reference_check_review: {
                    is_enabled: values.access_levels.reference_check_review.is_enabled,
                    actions: {}
                },
                custom_evaluation_review: {
                    is_enabled: values.access_levels.custom_evaluation_review.is_enabled,
                    actions: {}
                },
                one_way_interview_review: {
                    is_enabled: values.access_levels.one_way_interview_review.is_enabled,
                    actions: {}
                },
                evaluation_templates: {
                    is_enabled: values.access_levels.evaluation_templates.is_enabled,
                    actions: {
                        edit_evaluation_templates: values.access_levels.evaluation_templates.actions.edit_evaluation_templates,
                        view_evaluation_templates: values.access_levels.evaluation_templates.actions.view_evaluation_templates,
                        delete_evaluation_templates: values.access_levels.evaluation_templates.actions.delete_evaluation_templates,
                    }
                },
            },

        }))
    }
    const redirectToPath = (permissionObject) => {
        setIsRoutingLoading(true)
        if (pathname === "/company") {
            if ((permissionObject.access_levels.hiring_pipeline.is_enabled === true || (permissionObject.user_role === 0 && JSON.parse(localStorage.getItem('paymentStatus')) === false))) {
                setActiveUrl("company/pipelines");
                setIsRoutingLoading(false)
            }
            else if (permissionObject.access_levels.hiring_pipeline.is_enabled === true) {
                setActiveUrl("company/search-candidates");
                setIsRoutingLoading(false)
            }
            else if (permissionObject.access_levels.cv_review.is_enabled === true) {
                setActiveUrl("company/reviews");
                setIsRoutingLoading(false)
            } else if (permissionObject.access_levels.interviews.is_enabled === true) {
                setActiveUrl("company/interviews");
                setIsRoutingLoading(false)
            } else if (permissionObject.access_levels.external_assessment_review.is_enabled === true) {
                setActiveUrl("company/external-assignments");
                setIsRoutingLoading(false)
            } else if (permissionObject.access_levels.offer_handling.is_enabled === true) {
                setActiveUrl("company/offer-handling");
                setIsRoutingLoading(false)
            } else if (permissionObject.access_levels.onboarding.is_enabled === true) {
                setActiveUrl("company/pending-onboarding");
                setIsRoutingLoading(false)
            } else if (permissionObject.access_levels.approvals.is_enabled === true) {
                setActiveUrl("company/approvals");
                setIsRoutingLoading(false)
            } else if (permissionObject.access_levels.manage_users.is_enabled === true) {
                setActiveUrl("company/users");
                setIsRoutingLoading(false)
            } else if (permissionObject.access_levels.company_settings.is_enabled === true) {
                setActiveUrl("company/settings");
                setIsRoutingLoading(false)
            } else if (permissionObject.access_levels.billing.is_enabled === true) {
                setActiveUrl("company/billing");
                setIsRoutingLoading(false)
            } else if (permissionObject.access_levels.analytics.is_enabled === true) {
                setActiveUrl("company/analytics");
                setIsRoutingLoading(false)
            }
            else if (permissionObject.access_levels.quiz_templates.is_enabled === true) {
                setActiveUrl("company/quiz-templates");
                setIsRoutingLoading(false)
            } else if (permissionObject.access_levels.reference_check_review.is_enabled === true) {
                setActiveUrl("company/reference-checks");
                setIsRoutingLoading(false)
            }
            else if (permissionObject.access_levels.custom_evaluation_review.is_enabled === true) {
                setActiveUrl("company/custom-evaluations");
                setIsRoutingLoading(false)
            }
            else if (permissionObject.access_levels.one_way_interview_review.is_enabled === true) {
                setActiveUrl("company/one-way-interviews");
                setIsRoutingLoading(false)
            }
            else if (permissionObject.access_levels.evaluation_templates.is_enabled === true) {
                setActiveUrl("company/templates");
                setIsRoutingLoading(false)
            }
            else if (permissionObject.access_levels.one_way_interview_review.is_enabled === true) {
                setActiveUrl("company/interview-template");
                setIsRoutingLoading(false)
            }

        } else {
            let pathArray = window.location.pathname.split('/');
            if (pathArray[2] === "company") {
                if (pathArray[3] === "pipelines") {
                    setActiveUrl("company/pipelines");
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "reviews") {
                    setActiveUrl("company/reviews");
                    setIsRoutingLoading(false)
                }
                else if (pathArray[3] === "search-candidates") {
                    setActiveUrl("company/search-candidates");
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "interviews") {
                    setActiveUrl("company/interviews");
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "external-assignments") {
                    setActiveUrl("company/external-assignments");
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "scheduled-interviews") {
                    setActiveUrl("company/scheduled-interviews");
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "pending-interviews") {
                    setActiveUrl("company/pending-interviews");
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "users") {
                    setActiveUrl("company/users");
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "offer-handling") {
                    setActiveUrl("company/offer-handling");
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "filtered-candidates") {
                    setActiveUrl("company/filtered-candidates");
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "pending-onboarding") {
                    setActiveUrl("company/pending-onboarding");
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "approvals") {
                    setActiveUrl("company/approvals");
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "candidate") {
                    setActiveUrl(`company/candidate${window.location.search}`);
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "billing") {
                    setActiveUrl("company/billing");
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "settings") {
                    setActiveUrl("company/settings");
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "analytics") {
                    setActiveUrl("company/analytics");
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "quiz-templates") {
                    setActiveUrl("company/quiz-templates");
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "reference-checks") {
                    setActiveUrl("company/reference-checks");
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "custom-evaluations") {
                    setActiveUrl("company/custom-evaluations");
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "one-way-interviews") {
                    setActiveUrl("company/one-way-interviews");
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "templates") {
                    setActiveUrl("company/templates");
                    setIsRoutingLoading(false)
                } else if (pathArray[3] === "interview-template") {
                    setActiveUrl("company/interview-template");
                    setIsRoutingLoading(false)
                }
                else {
                    mainHistory('/company')
                }
            }

        }

    }

    const GetTaskValues = async () => {
        let respond = await getAssignedTasks();
        if (respond.success) {
            setAssignedTasks(respond.data);
        }
    }

    const GetVacancyPageURLPrefixStatus = async () => {
        let respond = await checkVacancyPageURLPrefix();
        if (respond.success) {
            setCompleteStatus(respond.data.is_mandatory_settings_configured);
        }
    }

    const sideNavExpand = (value) => {
        if (value === "offer") {
            setOfferExpand(prevState => !prevState);
        }
        else if (value === "interview") {
            setInterviewExpand(prevState => !prevState);
        }
    }
    const sideNavExpandNew = (value) => {
        if (value === "offer") {
            setOfferExpand(prevState => !prevState);
        }
        else if (value === "interview") {
            setInterviewExpand(prevState => !prevState);
        }
    }

    const handleCloseCreatePipelineModal = () => setCompleteStatus(true);

    useEffect(() => {
        let unmounted = false;
        const getPermissions = async () => {
            if (!unmounted) {
                let permissionObject = localStorage.getItem('Permissions');
                let value = JSON.parse(permissionObject)
                await setPermissionValues(JSON.parse(permissionObject));
                await GetTaskValues();
                await GetVacancyPageURLPrefixStatus();
                redirectToPath(value);
            }
        }
        getPermissions();
        return () => { unmounted = true };
    }, []);



    function newadd(w, d, s) {
        var a = d.getElementsByTagName('head')[0];
        var r = d.createElement('script');
        r.async = 1;
        r.src = s;
        r.setAttribute('id', 'usetifulScript');
        r.dataset.token = "407ae47a4956beb2afbce505f0a277f2";
        a.appendChild(r);
    }

    const CustomToggle = React.forwardRef(({ onClick }, ref) => {
        let pathArrays = window.location.pathname.split('/');
        return (
            <>
                <div className={styles.toggleIcon}>
                    {expand && <div className={styles.expandedToggleIcon}>
                        <a
                            className={styles.userIcon}
                            href=""
                            ref={ref}
                            onClick={e => {
                                e.preventDefault();
                                onClick(e);
                            }}
                        >
                            {(pathArrays[3] == "search-candidates" || (pathArrays[4] && pathArrays[3] == "interviews")) ?
                                null
                                :
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 3V21M21 12H7M7 12L14 19M7 12L14 5" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            }
                        </a>

                    </div>}
                    {!expand && <div className={styles.collapsedToggleIcon}>
                        <a
                            className={styles.userIcon}
                            href=""
                            ref={ref}
                            onClick={e => {
                                e.preventDefault();
                                onClick(e);
                            }}
                        >
                            <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" width="40" height="40" rx="8" fill="white" />
                                <path d="M29.5 29V11M11.5 20H25.5M25.5 20L18.5 13M25.5 20L18.5 27" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </a>
                    </div>}
                </div>
            </>
        );



    });

    return (
        <div>
            {
                completeStatus === false ?
                    <CompanySettingModal show={!completeStatus} setCompleteStatus={setCompleteStatus} handleClose={handleCloseCreatePipelineModal} stepLength={3} />
                    : null
            }
            {isRoutingLoading === false && activeUrl &&
                <>
                    <SideNav
                        id="side_nav"
                        className={styles.sideNavBar}
                        onSelect={(selected) => {
                            let to = `/${selected}`;
                            if (location.pathname !== to) {
                                mainHistory(to);
                            }
                            { (selected === "company/scheduled-interviews") || (selected === "company/pending-interviews") ? setInterviewExpand(true) : setInterviewExpand(false) }
                            { (selected === "company/offer-handling") || (selected === "company/filtered-candidates") ? setOfferExpand(true) : setOfferExpand(false) }
                        }}
                        onToggle={(e) => onToggle(e)}
                        expanded={isLockedState === true ? false : expand}
                    >
                        <SideNav.Toggle componentClass={CustomToggle} />
                        <SideNav.Nav defaultSelected={activeUrl} >
                            <div className={styles.appLogoDiv}>
                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/hiretrace-app-icon.png`} alt={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/hiretrace-app-icon.png`} className={`${((expand === false) || (isLockedState === true)) ? styles.companyNameHide : styles.appLogo}`} />
                                <p className={`${((expand === false) || (isLockedState === true)) ? styles.companyNameHide : styles.companyName}`}>Hiretrace</p>

                            </div>
                            {((expand === false) || (isLockedState === true)) ? <div className={styles.hiddendivcollapse}></div> : <div className={styles.hiddendiv}></div>}
                            {((permissions.access_levels.hiring_pipeline.is_enabled === true) || (permissions.user_role === 0 && JSON.parse(localStorage.getItem('paymentStatus')) === false)) ?
                                (<NavItem className={styles.middleNavItem} eventKey="company/pipelines" id="company_pipeline_side_nav">
                                    <NavIcon className={styles.navItemIcon}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M11 4.5H18.3C19.4201 4.5 19.9802 4.5 20.408 4.71799C20.7843 4.90973 21.0903 5.21569 21.282 5.59202C21.5 6.01984 21.5 6.57989 21.5 7.7V9C21.5 9.93188 21.5 10.3978 21.3478 10.7654C21.1448 11.2554 20.7554 11.6448 20.2654 11.8478C19.8978 12 19.4319 12 18.5 12M13 19.5H5.7C4.5799 19.5 4.01984 19.5 3.59202 19.282C3.21569 19.0903 2.90973 18.7843 2.71799 18.408C2.5 17.9802 2.5 17.4201 2.5 16.3V15C2.5 14.0681 2.5 13.6022 2.65224 13.2346C2.85523 12.7446 3.24458 12.3552 3.73463 12.1522C4.10218 12 4.56812 12 5.5 12M10.3 14.5H13.7C13.98 14.5 14.12 14.5 14.227 14.4455C14.3211 14.3976 14.3976 14.3211 14.4455 14.227C14.5 14.12 14.5 13.98 14.5 13.7V10.3C14.5 10.02 14.5 9.87996 14.4455 9.773C14.3976 9.67892 14.3211 9.60243 14.227 9.5545C14.12 9.5 13.98 9.5 13.7 9.5H10.3C10.02 9.5 9.87996 9.5 9.773 9.5545C9.67892 9.60243 9.60243 9.67892 9.5545 9.773C9.5 9.87996 9.5 10.02 9.5 10.3V13.7C9.5 13.98 9.5 14.12 9.5545 14.227C9.60243 14.3211 9.67892 14.3976 9.773 14.4455C9.87996 14.5 10.02 14.5 10.3 14.5ZM17.8 22H21.2C21.48 22 21.62 22 21.727 21.9455C21.8211 21.8976 21.8976 21.8211 21.9455 21.727C22 21.62 22 21.48 22 21.2V17.8C22 17.52 22 17.38 21.9455 17.273C21.8976 17.1789 21.8211 17.1024 21.727 17.0545C21.62 17 21.48 17 21.2 17H17.8C17.52 17 17.38 17 17.273 17.0545C17.1789 17.1024 17.1024 17.1789 17.0545 17.273C17 17.38 17 17.52 17 17.8V21.2C17 21.48 17 21.62 17.0545 21.727C17.1024 21.8211 17.1789 21.8976 17.273 21.9455C17.38 22 17.52 22 17.8 22ZM2.8 7H6.2C6.48003 7 6.62004 7 6.727 6.9455C6.82108 6.89757 6.89757 6.82108 6.9455 6.727C7 6.62004 7 6.48003 7 6.2V2.8C7 2.51997 7 2.37996 6.9455 2.273C6.89757 2.17892 6.82108 2.10243 6.727 2.0545C6.62004 2 6.48003 2 6.2 2H2.8C2.51997 2 2.37996 2 2.273 2.0545C2.17892 2.10243 2.10243 2.17892 2.0545 2.273C2 2.37996 2 2.51997 2 2.8V6.2C2 6.48003 2 6.62004 2.0545 6.727C2.10243 6.82108 2.17892 6.89757 2.273 6.9455C2.37996 7 2.51997 7 2.8 7Z" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </NavIcon>
                                <NavText className={styles.navItemText}>
                                    Vacancy Pipelines
                                </NavText>
                            </NavItem>)
                            : ''
                            }
                            {((permissions.access_levels.analytics.is_enabled === true) || (permissions.user_role === 0 && JSON.parse(localStorage.getItem('paymentStatus')) === false)) ?
                                (<NavItem className={styles.middleNavItem} eventKey="company/search-candidates?is_search_mode=true" id="company_candidate_search_nav">
                                    <NavIcon className={styles.navItemIcon}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="search-refraction">
                                                <path id="Icon" d="M21 21L16.65 16.65M11 6C13.7614 6 16 8.23858 16 11M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </g>
                                        </svg>
                                    </NavIcon>
                                    <NavText className={styles.navItemText}>
                                        Candidate Search
                                    </NavText>
                                </NavItem>)
                                :
                                ''
                            }
                            {((permissions.access_levels.analytics.is_enabled === true) || (permissions.user_role === 0 && JSON.parse(localStorage.getItem('paymentStatus')) === false)) ?
                                (<NavItem className={styles.middleNavItem} eventKey="company/analytics" id="company_analytics_side_nav">
                                    <NavIcon className={styles.navItemIcon} >
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="bar-chart-square-02">
                                                <path id="Icon" d="M8 15V17M12 11V17M16 7V17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </g>
                                        </svg>
                                    </NavIcon>
                                    <NavText className={styles.navItemText}>
                                        Analytics
                                    </NavText>
                                </NavItem>)
                                :
                                ''
                            }
                            {((permissions.access_levels.hiring_pipeline.is_enabled === true || permissions.access_levels.analytics.is_enabled === true) && JSON.parse(localStorage.getItem('paymentStatus')) === false) ?
                                <hr className={styles.divider} />
                                :
                                null}


                            {((permissions.access_levels.cv_review.is_enabled === true) || (permissions.user_role === 0 && JSON.parse(localStorage.getItem('paymentStatus')) === false)) ?
                                (<NavItem className={styles.middleNavItem} eventKey="company/reviews" id="company_reviews_side_nav">
                                    <NavIcon className={styles.navItemIcon}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M2 12.0001L11.6422 16.8212C11.7734 16.8868 11.839 16.9196 11.9078 16.9325C11.9687 16.9439 12.0313 16.9439 12.0922 16.9325C12.161 16.9196 12.2266 16.8868 12.3578 16.8212L22 12.0001M2 17.0001L11.6422 21.8212C11.7734 21.8868 11.839 21.9196 11.9078 21.9325C11.9687 21.9439 12.0313 21.9439 12.0922 21.9325C12.161 21.9196 12.2266 21.8868 12.3578 21.8212L22 17.0001M2 7.00006L11.6422 2.17895C11.7734 2.11336 11.839 2.08056 11.9078 2.06766C11.9687 2.05622 12.0313 2.05622 12.0922 2.06766C12.161 2.08056 12.2266 2.11336 12.3578 2.17895L22 7.00006L12.3578 11.8212C12.2266 11.8868 12.161 11.9196 12.0922 11.9325C12.0313 11.9439 11.9687 11.9439 11.9078 11.9325C11.839 11.9196 11.7734 11.8868 11.6422 11.8212L2 7.00006Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                    </NavIcon>
                                    <NavText className={styles.navItemText}>
                                        CV Reviews
                                        <span style={{ marginLeft: '83px' }}>
                                            {assignedTasks && assignedTasks.cv_reviews > 0 &&
                                                (<Badge bg="none" className={styles.badgeCounts}>{assignedTasks.cv_reviews}</Badge>)
                                            }
                                        </span>
                                    </NavText>
                                </NavItem>)
                                :
                                ''
                            }
                            {((permissions.access_levels.schedule_interviews.is_enabled === true) || (permissions.user_role === 0 && JSON.parse(localStorage.getItem('paymentStatus')) === false)) ?
                                (<NavItem className={styles.middleNavItem} eventKey="#" subnavClassName={styles.subnav} onClick={() => {setState(true); sideNavExpand("interview");} } id="company_sched_interview_side_nav" expanded={offerExpand === true ? sideNavExpandNew("interview") : false}>
                                    <NavIcon className={styles.navItemIcon} >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </NavIcon>
                                    <NavText >
                                        Sch. Interviews
                                        <span style={(assignedTasks.interviews_to_schedule > 0 && assignedTasks.scheduled_interviews > 0) ? { marginLeft: '10px' } : { marginLeft: '32px' }}>
                                            {assignedTasks && (assignedTasks.scheduled_interviews > 0 || assignedTasks.interviews_to_schedule > 0) && interviewExpand === false &&
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M5 7.5L10 12.5L15 7.5" stroke="#667085" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            }
                                            {assignedTasks.scheduled_interviews > 0 && <span className={styles.spaceHandle}></span>}
                                            {assignedTasks && assignedTasks.scheduled_interviews > 0 && interviewExpand === false &&
                                                (<Badge bg="none" className={styles.badgeCounts}>{assignedTasks.scheduled_interviews}</Badge>)
                                            }
                                            {assignedTasks.interviews_to_schedule > 0 && <span className={styles.spaceHandle}></span>}
                                            {assignedTasks && assignedTasks.interviews_to_schedule > 0 && interviewExpand === false &&
                                                (<Badge bg="none" className={styles.badgeCounts}>{assignedTasks.interviews_to_schedule}</Badge>)
                                            }

                                        </span>
                                        <span style={(assignedTasks.scheduled_interviews > 0 || assignedTasks.interviews_to_schedule > 0) ? { marginLeft: '10px' } : { marginLeft: '33px' }}>
                                            {assignedTasks && (assignedTasks.scheduled_interviews > 0 || assignedTasks.interviews_to_schedule > 0) && interviewExpand === true &&
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
                                                    <path d="M11 6.5L6 1.5L1 6.5" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" stroke="#667085" />
                                                </svg>
                                            }
                                        </span>

                                    </NavText>
                                <NavItem eventKey="company/scheduled-interviews" subnavClassName={styles.subnav} id="adminPanel_scheduledInterviewNavTab">
                                        <NavText>
                                            Scheduled Interviews
                                            <span style={{ marginLeft: '30px' }}>
                                                {assignedTasks && assignedTasks.scheduled_interviews > 0 &&
                                                    (<Badge bg="none" className={styles.badgeCounts}>{assignedTasks.scheduled_interviews}</Badge>)
                                                }
                                            </span>
                                        </NavText>
                                    </NavItem>
                                    <NavItem eventKey="company/pending-interviews" subnavClassName={styles.subnav} id="adminPanel_pendingInterviewNavTab">
                                        <NavText>
                                            Pending Interviews
                                            <span style={{ marginLeft: '45px' }}>
                                                {assignedTasks && assignedTasks.interviews_to_schedule > 0 &&
                                                    (<Badge bg="none" className={styles.badgeCounts}>{assignedTasks.interviews_to_schedule}</Badge>)
                                                }
                                            </span>
                                        </NavText>
                                    </NavItem>
                                </NavItem>)
                                :
                                ''
                            }
                            {((permissions.access_levels.interviews.is_enabled === true) || (permissions.user_role === 0 && JSON.parse(localStorage.getItem('paymentStatus')) === false)) ?
                                (<NavItem className={styles.middleNavItem} eventKey="company/interviews" id="company_interviews_side_nav">
                                    <NavIcon className={styles.navItemIcon}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M22 8.93137C22 8.32555 22 8.02265 21.8802 7.88238C21.7763 7.76068 21.6203 7.69609 21.4608 7.70865C21.2769 7.72312 21.0627 7.93731 20.6343 8.36569L17 12L20.6343 15.6343C21.0627 16.0627 21.2769 16.2769 21.4608 16.2914C21.6203 16.3039 21.7763 16.2393 21.8802 16.1176C22 15.9774 22 15.6744 22 15.0686V8.93137Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M2 9.8C2 8.11984 2 7.27976 2.32698 6.63803C2.6146 6.07354 3.07354 5.6146 3.63803 5.32698C4.27976 5 5.11984 5 6.8 5H12.2C13.8802 5 14.7202 5 15.362 5.32698C15.9265 5.6146 16.3854 6.07354 16.673 6.63803C17 7.27976 17 8.11984 17 9.8V14.2C17 15.8802 17 16.7202 16.673 17.362C16.3854 17.9265 15.9265 18.3854 15.362 18.673C14.7202 19 13.8802 19 12.2 19H6.8C5.11984 19 4.27976 19 3.63803 18.673C3.07354 18.3854 2.6146 17.9265 2.32698 17.362C2 16.7202 2 15.8802 2 14.2V9.8Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </NavIcon>
                                    <NavText className={styles.navItemText}>
                                        Interviews
                                        <span style={{ marginLeft: '93px' }}>
                                            {assignedTasks && assignedTasks.interviews > 0 &&
                                                (<Badge bg="none" className={styles.badgeCounts}>{assignedTasks.interviews}</Badge>)
                                            }
                                        </span>
                                    </NavText>
                                </NavItem>)
                                :
                                ''
                            }
                            {((permissions.access_levels.external_assessment_review.is_enabled === true) || (permissions.user_role === 0 && JSON.parse(localStorage.getItem('paymentStatus')) === false)) ?
                                (<NavItem className={styles.middleNavItem} eventKey="company/external-assignments" id="company_external_assessments_side_nav">
                                    <NavIcon className={styles.navItemIcon}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M12 20H5.2C4.07989 20 3.51984 20 3.09202 19.782C2.71569 19.5903 2.40973 19.2843 2.21799 18.908C2 18.4802 2 17.9201 2 16.8V7.2C2 6.07989 2 5.51984 2.21799 5.09202C2.40973 4.71569 2.71569 4.40973 3.09202 4.21799C3.51984 4 4.07989 4 5.2 4H5.6C7.84021 4 8.96031 4 9.81596 4.43597C10.5686 4.81947 11.1805 5.43139 11.564 6.18404C12 7.03968 12 8.15979 12 10.4M12 20V10.4M12 20H18.8C19.9201 20 20.4802 20 20.908 19.782C21.2843 19.5903 21.5903 19.2843 21.782 18.908C22 18.4802 22 17.9201 22 16.8V7.2C22 6.07989 22 5.51984 21.782 5.09202C21.5903 4.71569 21.2843 4.40973 20.908 4.21799C20.4802 4 19.9201 4 18.8 4H18.4C16.1598 4 15.0397 4 14.184 4.43597C13.4314 4.81947 12.8195 5.43139 12.436 6.18404C12 7.03968 12 8.15979 12 10.4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </NavIcon>
                                    <NavText className={styles.navItemText}>
                                        Ext. Assignments
                                        <span style={{ marginLeft: '46px' }}>
                                            {assignedTasks && assignedTasks.external_assessments > 0 &&
                                                (<Badge bg="none" className={styles.badgeCounts}>{assignedTasks.external_assessments}</Badge>)
                                            }
                                        </span>
                                    </NavText>
                                </NavItem>)
                                :
                                ''
                            }
                            {((permissions.access_levels.reference_check_review.is_enabled === true) || (permissions.user_role === 0 && JSON.parse(localStorage.getItem('paymentStatus')) === false)) ?
                                (<NavItem className={styles.middleNavItem} eventKey="company/reference-checks" id="company_reference_check_side_nav">
                                    <NavIcon className={styles.navItemIcon}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M20 12.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M14 11H8M10 15H8M16 7H8M14.5 19L16.5 21L21 16.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>                                            </NavIcon>
                                    <NavText className={styles.navItemText}>
                                        Reference Check
                                        <span style={{ marginLeft: '49px' }}>
                                            {assignedTasks && assignedTasks.reference_checks > 0 &&
                                                (<Badge bg="none" className={styles.badgeCounts}>{assignedTasks.reference_checks}</Badge>)
                                            }
                                        </span>
                                    </NavText>
                                </NavItem>)
                                :
                                ''
                            }
                            {((permissions.access_levels.custom_evaluation_review.is_enabled === true) || (permissions.user_role === 0 && JSON.parse(localStorage.getItem('paymentStatus')) === false)) ?
                                (<NavItem className={styles.middleNavItem} eventKey="company/custom-evaluations" id="company_custom_evaluation_side_nav">
                                    <NavIcon className={styles.navItemIcon}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M20.5 7.27777L12 12M12 12L3.49997 7.27777M12 12L12 21.5M14 20.8889L12.777 21.5683C12.4934 21.7259 12.3516 21.8047 12.2015 21.8356C12.0685 21.8629 11.9315 21.8629 11.7986 21.8356C11.6484 21.8047 11.5066 21.7259 11.223 21.5683L3.82297 17.4572C3.52346 17.2908 3.37368 17.2076 3.26463 17.0893C3.16816 16.9846 3.09515 16.8605 3.05048 16.7253C3 16.5725 3 16.4012 3 16.0586V7.94147C3 7.59883 3 7.42751 3.05048 7.27471C3.09515 7.13953 3.16816 7.01545 3.26463 6.91076C3.37368 6.79242 3.52345 6.70922 3.82297 6.54282L11.223 2.43171C11.5066 2.27415 11.6484 2.19537 11.7986 2.16448C11.9315 2.13715 12.0685 2.13715 12.2015 2.16448C12.3516 2.19537 12.4934 2.27415 12.777 2.43171L20.177 6.54282C20.4766 6.70922 20.6263 6.79242 20.7354 6.91076C20.8318 7.01545 20.9049 7.13953 20.9495 7.27471C21 7.4275 21 7.59883 21 7.94147L21 12.5M7.5 4.50002L16.5 9.50002M19 21V15M16 18H22" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </NavIcon>
                                    <NavText className={styles.navItemText}>
                                        Custom Evaluations
                                        <span style={{ marginLeft: '32px' }}>
                                            {assignedTasks && assignedTasks.custom_evaluations > 0 &&
                                                (<Badge bg="none" className={styles.badgeCounts}>{assignedTasks.custom_evaluations}</Badge>)
                                            }
                                        </span>
                                    </NavText>
                                </NavItem>)
                                :
                                ''
                            }
                            {((permissions.access_levels.one_way_interview_review.is_enabled === true) || (permissions.user_role === 0 && JSON.parse(localStorage.getItem('paymentStatus')) === false)) ?
                                (<NavItem className={styles.middleNavItem} eventKey="company/one-way-interviews" id="company_one_way_interview_side_nav">
                                    <NavIcon className={styles.navItemIcon}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                            <path d="M6.94075 19.25C8.16431 18.6631 9.54239 18.3333 10.9999 18.3333C12.4574 18.3333 13.8355 18.6631 15.0591 19.25M6.23325 15.5833H15.7666C17.3067 15.5833 18.0768 15.5833 18.6651 15.2836C19.1825 15.0199 19.6032 14.5993 19.8669 14.0818C20.1666 13.4936 20.1666 12.7235 20.1666 11.1833V7.15C20.1666 5.60986 20.1666 4.83978 19.8669 4.25153C19.6032 3.73408 19.1825 3.31338 18.6651 3.04973C18.0768 2.75 17.3067 2.75 15.7666 2.75H6.23325C4.69311 2.75 3.92304 2.75 3.33478 3.04973C2.81733 3.31338 2.39664 3.73408 2.13298 4.25153C1.83325 4.83978 1.83325 5.60986 1.83325 7.15V11.1833C1.83325 12.7235 1.83325 13.4936 2.13298 14.0818C2.39664 14.5993 2.81733 15.0199 3.33478 15.2836C3.92304 15.5833 4.69311 15.5833 6.23325 15.5833Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </NavIcon>
                                    <NavText style={{ color: 'black' }} className={styles.navItemText}>
                                        One Way Interview
                                        <span style={{ marginLeft: '38px' }}>
                                            {assignedTasks && assignedTasks.one_way_interviews > 0 &&
                                                (<Badge bg="none" className={styles.badgeCounts}>{assignedTasks.one_way_interviews}</Badge>)
                                            }
                                        </span>
                                    </NavText>
                                </NavItem>)
                                :
                                ''
                            }
                            {((permissions.access_levels.approvals.is_enabled === true) || (permissions.user_role === 0 && JSON.parse(localStorage.getItem('paymentStatus')) === false)) ?
                                (<NavItem className={styles.middleNavItem} eventKey="company/approvals" id="company_approvals_side_nav">
                                    <NavIcon className={styles.navItemIcon}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </NavIcon>
                                    <NavText className={styles.navItemText}>
                                    Offer Approvals
                                        <span style={{ marginLeft: '60px' }}>
                                            {assignedTasks && assignedTasks.offer_approvals > 0 &&
                                                (<Badge bg="none" className={styles.badgeCounts}>{assignedTasks.offer_approvals}</Badge>)
                                            }
                                        </span>
                                    </NavText>
                                </NavItem>)
                                :
                                ''
                            }
                            {((permissions.access_levels.offer_handling.is_enabled === true) || (permissions.user_role === 0 && JSON.parse(localStorage.getItem('paymentStatus')) === false)) ?
                                (<NavItem className={styles.middleNavItem} eventKey="##" subnavClassName={styles.subnav} onClick={() => {setState(true); sideNavExpand("offer");}} id="company_offer_side_nav" expanded={interviewExpand === true ? sideNavExpandNew("offer") : false}>
                                    <NavIcon className={styles.navItemIcon} >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M2 14C2 14 2.12132 14.8492 5.63604 18.364C9.15076 21.8787 14.8492 21.8787 18.364 18.364C19.6092 17.1187 20.4133 15.5993 20.7762 14M2 14V20M2 14H8M22 10C22 10 21.8787 9.15076 18.364 5.63604C14.8492 2.12132 9.15076 2.12132 5.63604 5.63604C4.39076 6.88131 3.58669 8.40072 3.22383 10M22 10V4M22 10H16" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </NavIcon>
                                    <NavText className={styles.navItemText}>
                                        Offer Handling
                                        <span style={(assignedTasks.offer_handling > 0 && assignedTasks.filtered_candidates > 0) ? { marginLeft: '14px' } : { marginLeft: '35px' }}>
                                            {assignedTasks && (assignedTasks.offer_handling > 0 || assignedTasks.filtered_candidates > 0) && offerExpand === false &&
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M5 7.5L10 12.5L15 7.5" stroke="#667085" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            }
                                            {assignedTasks.offer_handling > 0 && <span className={styles.spaceHandle}></span>}
                                            {assignedTasks && assignedTasks.offer_handling > 0 && offerExpand === false &&
                                                (<Badge bg="none" className={styles.badgeCounts}>{assignedTasks.offer_handling}</Badge>)
                                            }
                                            {assignedTasks.filtered_candidates > 0 && <span className={styles.spaceHandle}></span>}
                                            {assignedTasks && assignedTasks.filtered_candidates > 0 && offerExpand === false &&
                                                (<Badge bg="none" className={styles.badgeCounts}>{assignedTasks.filtered_candidates}</Badge>)
                                            }
                                        </span>
                                        <span style={(assignedTasks.offer_handling > 0 || assignedTasks.filtered_candidates > 0) ? { marginLeft: '20px' } : { marginLeft: '35px' }} >
                                            {assignedTasks && (assignedTasks.offer_handling > 0 || assignedTasks.filtered_candidates > 0) && offerExpand === true &&
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
                                                    <path d="M11 6.5L6 1.5L1 6.5" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" stroke="#667085" />
                                                </svg>
                                            }
                                        </span>
                                    </NavText>
                                    <NavItem eventKey="company/offer-handling" subnavClassName={styles.subnav}>
                                        <NavText>
                                            Processing Offers
                                            <span style={{ marginLeft: '54px' }}>
                                                {assignedTasks && assignedTasks.offer_handling > 0 &&
                                                    (<Badge bg="none" className={styles.badgeCounts}>{assignedTasks.offer_handling}</Badge>)
                                                }
                                            </span>
                                        </NavText>
                                    </NavItem>
                                    <NavItem eventKey="company/filtered-candidates" subnavClassName={styles.subnav}>
                                        <NavText>
                                            Filtered Candidates
                                            <span style={{ marginLeft: '42px' }}>
                                                {assignedTasks && assignedTasks.filtered_candidates > 0 &&
                                                    (<Badge bg="none" className={styles.badgeCounts}>{assignedTasks.filtered_candidates}</Badge>)
                                                }
                                            </span>
                                        </NavText>
                                    </NavItem>
                                </NavItem>)
                                :
                                ''
                            }
                            {((permissions.access_levels.onboarding.is_enabled === true) || (permissions.user_role === 0 && JSON.parse(localStorage.getItem('paymentStatus')) === false)) ?
                                (<NavItem className={styles.middleNavItem} eventKey="company/pending-onboarding" id="company_onboarding_side_nav">
                                    <NavIcon className={styles.navItemIcon}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M15 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11985 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H15M10 7L15 12M15 12L10 17M15 12L3 12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </NavIcon>
                                    <NavText className={styles.navItemText}>
                                        Pending Onboarding
                                        <span style={{ marginLeft: '27px' }}>
                                            {assignedTasks && assignedTasks.onboardings > 0 &&
                                                (<Badge bg="none" className={styles.badgeCounts}>{assignedTasks.onboardings}</Badge>)
                                            }
                                        </span>
                                    </NavText>
                                </NavItem>)
                                :
                                ''
                            }

                            {((permissions.access_levels.evaluation_templates.is_enabled === true) || (permissions.user_role === 0 && JSON.parse(localStorage.getItem('paymentStatus')) === false)) ?
                                (<NavItem className={styles.middleNavItem} eventKey="company/templates" id="company_evaluation_templates_side_nav">
                                    <NavIcon className={styles.navItemIcon}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M11 3.99998H6.8C5.11984 3.99998 4.27976 3.99998 3.63803 4.32696C3.07354 4.61458 2.6146 5.07353 2.32698 5.63801C2 6.27975 2 7.11983 2 8.79998V17.2C2 18.8801 2 19.7202 2.32698 20.362C2.6146 20.9264 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9264 19.673 20.362C20 19.7202 20 18.8801 20 17.2V13M7.99997 16H9.67452C10.1637 16 10.4083 16 10.6385 15.9447C10.8425 15.8957 11.0376 15.8149 11.2166 15.7053C11.4184 15.5816 11.5914 15.4086 11.9373 15.0627L21.5 5.49998C22.3284 4.67156 22.3284 3.32841 21.5 2.49998C20.6716 1.67156 19.3284 1.67155 18.5 2.49998L8.93723 12.0627C8.59133 12.4086 8.41838 12.5816 8.29469 12.7834C8.18504 12.9624 8.10423 13.1574 8.05523 13.3615C7.99997 13.5917 7.99997 13.8363 7.99997 14.3255V16Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </NavIcon>
                                    <NavText>
                                        Templates
                                    </NavText>
                                </NavItem>)
                                :
                                ''
                            }

                            <hr className={styles.divider} /> {/* Divider */}

                            {((permissions.access_levels.manage_users.is_enabled === true) || (permissions.user_role === 0 && JSON.parse(localStorage.getItem('paymentStatus')) === false)) ?
                                (<NavItem className={styles.middleNavItem} eventKey="company/users" id="company_users_side_nav">
                                    <NavIcon className={styles.navItemIcon}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </NavIcon>
                                    <NavText>
                                        Manage Users
                                    </NavText>
                                </NavItem>)
                                :
                                ''
                            }

                            {((permissions.access_levels.company_settings.is_enabled === true) || (permissions.user_role === 0 && JSON.parse(localStorage.getItem('paymentStatus')) === false)) ?
                                (<NavItem className={styles.middleNavItem} eventKey="company/settings" id="company_settings_side_nav">
                                    <NavIcon>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M9.39504 19.3711L9.97949 20.6856C10.1532 21.0768 10.4368 21.4093 10.7957 21.6426C11.1547 21.8759 11.5736 22.0001 12.0017 22C12.4298 22.0001 12.8488 21.8759 13.2077 21.6426C13.5667 21.4093 13.8502 21.0768 14.0239 20.6856L14.6084 19.3711C14.8164 18.9047 15.1664 18.5159 15.6084 18.26C16.0532 18.0034 16.5677 17.8941 17.0784 17.9478L18.5084 18.1C18.934 18.145 19.3636 18.0656 19.7451 17.8713C20.1265 17.6771 20.4434 17.3763 20.6573 17.0056C20.8714 16.635 20.9735 16.2103 20.951 15.7829C20.9285 15.3555 20.7825 14.9438 20.5306 14.5978L19.6839 13.4344C19.3825 13.0171 19.2214 12.5148 19.2239 12C19.2238 11.4866 19.3864 10.9864 19.6884 10.5711L20.535 9.40778C20.7869 9.06175 20.933 8.65007 20.9554 8.22267C20.9779 7.79528 20.8759 7.37054 20.6617 7C20.4478 6.62923 20.1309 6.32849 19.7495 6.13423C19.3681 5.93997 18.9385 5.86053 18.5128 5.90556L17.0828 6.05778C16.5722 6.11141 16.0576 6.00212 15.6128 5.74556C15.1699 5.48825 14.8199 5.09736 14.6128 4.62889L14.0239 3.31444C13.8502 2.92317 13.5667 2.59072 13.2077 2.3574C12.8488 2.12408 12.4298 1.99993 12.0017 2C11.5736 1.99993 11.1547 2.12408 10.7957 2.3574C10.4368 2.59072 10.1532 2.92317 9.97949 3.31444L9.39504 4.62889C9.18797 5.09736 8.83792 5.48825 8.39504 5.74556C7.95026 6.00212 7.43571 6.11141 6.92504 6.05778L5.4906 5.90556C5.06493 5.86053 4.63534 5.93997 4.25391 6.13423C3.87249 6.32849 3.55561 6.62923 3.34171 7C3.12753 7.37054 3.02549 7.79528 3.04798 8.22267C3.07046 8.65007 3.2165 9.06175 3.46838 9.40778L4.31504 10.5711C4.61698 10.9864 4.77958 11.4866 4.77949 12C4.77958 12.5134 4.61698 13.0137 4.31504 13.4289L3.46838 14.5922C3.2165 14.9382 3.07046 15.3499 3.04798 15.7773C3.02549 16.2047 3.12753 16.6295 3.34171 17C3.55582 17.3706 3.87274 17.6712 4.25411 17.8654C4.63548 18.0596 5.06496 18.1392 5.4906 18.0944L6.9206 17.9422C7.43127 17.8886 7.94581 17.9979 8.3906 18.2544C8.83513 18.511 9.18681 18.902 9.39504 19.3711Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M11.9999 15C13.6568 15 14.9999 13.6569 14.9999 12C14.9999 10.3431 13.6568 9 11.9999 9C10.3431 9 8.99992 10.3431 8.99992 12C8.99992 13.6569 10.3431 15 11.9999 15Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </NavIcon>
                                    <NavText className={styles.navItemText}>
                                        Company Settings
                                    </NavText>
                                </NavItem>)
                                :
                                ''
                            }
                            {
                                (<NavItem className={styles.middleNavItem} eventKey="my-settings/customer-support" id="customer_support_side_nav">
                                    <NavIcon className={styles.navItemIcon} >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M9.13626 9.13628L4.92893 4.92896M4.92893 19.0711L9.16797 14.8321M14.8611 14.8638L19.0684 19.0711M19.0684 4.92896L14.8287 9.16862M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </NavIcon>
                                    <NavText className={styles.navItemText}>
                                        Support
                                    </NavText>
                                </NavItem>)
                            }

                            <hr className={styles.divider} /> {/* Divider */}

                            {permissions.access_levels.billing.is_enabled === true || permissions.user_role === 0 ?
                                (<NavItem className={styles.middleNavItem} eventKey="company/billing" id="company_billing_side_nav">
                                    <NavIcon className={styles.navItemIcon}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M14 9H11.5C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.5C13.3284 12 14 12.6716 14 13.5C14 14.3284 13.3284 15 12.5 15H10M12 8V9M12 15V16M18 12H18.01M6 12H6.01M2 8.2L2 15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5L5.2 5C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.07989 2 8.2ZM18.5 12C18.5 12.2761 18.2761 12.5 18 12.5C17.7239 12.5 17.5 12.2761 17.5 12C17.5 11.7239 17.7239 11.5 18 11.5C18.2761 11.5 18.5 11.7239 18.5 12ZM6.5 12C6.5 12.2761 6.27614 12.5 6 12.5C5.72386 12.5 5.5 12.2761 5.5 12C5.5 11.7239 5.72386 11.5 6 11.5C6.27614 11.5 6.5 11.7239 6.5 12Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </NavIcon>
                                    <NavText className={styles.navItemText}>
                                        Billing
                                    </NavText>
                                </NavItem>)
                                :
                                ''
                            }
                            <div className={styles.verticalLine}></div>
                        </SideNav.Nav>
                    </SideNav>

                    <main
                        className={styles.bodyView}
                        style={{
                            marginLeft: (expand && (isLockedState === false)) ? 275 : 65
                        }}>

                        <div className="content">
                            <Routes>
                                <Route path="/pipelines" element={<HiringPipelines permissions={permissions.access_levels.hiring_pipeline} role={permissions.user_role} history={mainHistory} title="test" toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} />} />
                                <Route path="/search-candidates" element={<CandidateSearch permissions={permissions.access_levels.hiring_pipeline} role={permissions.user_role} GetTaskValues={GetTaskValues} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} />} />
                                <Route path="/pipelines/:id" element={<ViewPipeline permissions={permissions.access_levels.hiring_pipeline} role={permissions.user_role} histry={mainHistory} mainHistory={mainHistory} />} />
                                <Route path="/pipelines/:id/edit" element={<EditPipeline permissions={permissions.access_levels.hiring_pipeline} role={permissions.user_role} GetTaskValues={GetTaskValues} mainHistory={mainHistory} />} />
                                <Route path="/settings" element={<CompanySettings permissions={permissions.access_levels.company_settings} role={permissions.user_role} GetTaskValues={GetTaskValues} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} />} >
                                    <Route path='general' element={<General />} />
                                    <Route path='integrations' element={<Integrations />} />
                                    <Route path='hris' element={<HRISIntegration />} />
                                </Route>
                                <Route path="/reviews" element={<CVReview permissions={permissions.access_levels.cv_review} role={permissions.user_role} history={mainHistory} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} />} />
                                <Route path="reviews/group" element={<ViewCVGroup permissions={permissions.access_levels.cv_review} role={permissions.user_role} history={mainHistory} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} />} />
                                <Route path="/reviews/:id" element={<ViewCV permissions={permissions.access_levels.cv_review} role={permissions.user_role} GetTaskValues={GetTaskValues} mainHistory={mainHistory} />} />
                                <Route path="/interviews" element={<Interviews permissions={permissions.access_levels.interviews} role={permissions.user_role} history={mainHistory} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} />} />
                                <Route path="/interviews/:id" element={<SingleInterview permissions={permissions.access_levels.interviews} role={permissions.user_role} GetTaskValues={GetTaskValues} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} />} />
                                <Route path="/external-assignments" element={<OtherReviews permissions={permissions.access_levels.interviews} role={permissions.user_role} history={mainHistory} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} />} />
                                <Route path="/external-assignments/group" element={<ViewOtherReviews permissions={permissions.access_levels.interviews} role={permissions.user_role} history={mainHistory} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} GetTaskValues={GetTaskValues} />} />
                                <Route path="/scheduled-interviews" element={<SheduledInterviews permissions={permissions.access_levels.schedule_interviews} role={permissions.user_role} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} GetTaskValues={GetTaskValues} />} >
                                    <Route path='table-view' element={<TableViewInterviews />} />
                                    <Route path='calendar-view' element={<CalendarViewInterviews />} />
                                </Route>
                                <Route path="/pending-interviews" element={<PendingInterviews permissions={permissions.access_levels.schedule_interviews} role={permissions.user_role} GetTaskValues={GetTaskValues} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} />} />
                                <Route path="/users" element={<ManageUsers permissions={permissions.access_levels.manage_users} role={permissions.user_role} toggleInterviewView={toggleInterviewView} isLockedState={isLockedState} mainHistory={mainHistory} />} />
                                <Route path="/offer-handling" element={<OfferHandling permissions={permissions.access_levels.offer_handling} role={permissions.user_role} GetTaskValues={GetTaskValues} toggleInterviewView={toggleInterviewView} isLockedState={isLockedState} mainHistory={mainHistory} />} />
                                <Route path="/filtered-candidates" element={<FilteredCandidates permissions={permissions.access_levels.offer_handling} role={permissions.user_role} GetTaskValues={GetTaskValues} toggleInterviewView={toggleInterviewView} isLockedState={isLockedState} mainHistory={mainHistory} />} />
                                <Route path="/pending-onboarding" element={<PendingOnboarding permissions={permissions.access_levels.onboarding} role={permissions.user_role} GetTaskValues={GetTaskValues} toggleInterviewView={toggleInterviewView} isLockedState={isLockedState} mainHistory={mainHistory} />} />
                                <Route path="/approvals" element={<OfferApprovals permissions={permissions.access_levels.approvals} role={permissions.user_role} GetTaskValues={GetTaskValues} toggleInterviewView={toggleInterviewView} isLockedState={isLockedState} mainHistory={mainHistory} />} />
                                <Route path="/candidate" element={<ViewSingleCandidate permissions={permissions.access_levels.hiring_pipeline} role={permissions.user_role} GetTaskValues={GetTaskValues} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} />} />
                                <Route path="/billing" element={<Billing permissions={permissions.access_levels.billing} role={permissions.user_role} GetTaskValues={GetTaskValues} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} />} />
                                <Route path="/analytics" element={<Analytics permissions={permissions.access_levels.analytics} role={permissions.user_role} GetTaskValues={GetTaskValues} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} />} />
                                <Route path="/reference-checks" element={<ReferenceCheck permissions={permissions.access_levels.cv_review} role={permissions.user_role} history={mainHistory} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} />} />
                                <Route path="/reference-checks/group" element={<ViewReferenceCheckGroup permissions={permissions.access_levels.cv_review} role={permissions.user_role} history={mainHistory} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} />} />
                                <Route path="/reference-checks/:id" element={<ViewReferenceChecks permissions={permissions.access_levels.cv_review} role={permissions.user_role} GetTaskValues={GetTaskValues} mainHistory={mainHistory} />} />
                                <Route path="/custom-evaluations" element={<CustomEvaluation permissions={permissions.access_levels.cv_review} role={permissions.user_role} history={mainHistory} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} />} />
                                <Route path="/custom-evaluations/group" element={<ViewCustomEvaluationGroup permissions={permissions.access_levels.cv_review} role={permissions.user_role} history={mainHistory} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} />} />
                                <Route path="/custom-evaluations/:id" element={<ViewCustomEvaluations permissions={permissions.access_levels.cv_review} role={permissions.user_role} GetTaskValues={GetTaskValues} mainHistory={mainHistory} />} />
                                <Route path="/one-way-interviews" element={<OneWayInterview permissions={permissions.access_levels.cv_review} role={permissions.user_role} history={mainHistory} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} />} />
                                <Route path="/one-way-interviews/group" element={<ViewOneWayInterviewGroup permissions={permissions.access_levels.cv_review} role={permissions.user_role} history={mainHistory} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} />} />
                                <Route path="/one-way-interviews/:id" element={<ViewOneWayInterview permissions={permissions.access_levels.cv_review} role={permissions.user_role} GetTaskValues={GetTaskValues} mainHistory={mainHistory} />} />
                                <Route path="/templates" element={<EvaluationTemplates permissions={permissions.access_levels.cv_review} role={permissions.user_role} history={mainHistory} GetTaskValues={GetTaskValues} toggleInterviewView={toggleInterviewView} mainHistory={mainHistory} />} >
                                    <Route path='one-way-interview-templates' element={<OneWayInterviewTemplates />} />
                                    <Route path='quiz-templates' element={<QuizTemplates />} />
                                </Route>
                                <Route path="/quiz-templates/:id" element={<ViewQuizTemplates permissions={permissions.access_levels.quiz_templates} role={permissions.user_role} histry={mainHistory} mainHistory={mainHistory} />} />
                                {/* <Route path="/interview-template/:id" element={props => <ViewOneWayInterviewTemplate permissions={permissions.access_levels.cv_review} role={permissions.user_role} histry={history} mainHistory={mainHistory} />} /> */}
                                <Route path="/interview-template/:id/edit" element={<EditOneWayInterviewTemplate permissions={permissions.access_levels.cv_review} role={permissions.user_role} histry={mainHistory} mainHistory={mainHistory} />} />
                                <Route path="" element={<NotFound permissions={permissions} />} />
                            </Routes>
                        </div>
                    </main>
                </>
            }
        </div>
    )
}

export default AdminPanel;

